import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { products } from '../../product-list/data/products.data';
import { Order } from 'src/app/shared/models/order';
import { OrderService } from 'src/app/shared/services/order-service';
import { LoaderService } from 'src/app/shared/services/loader-service';

@Component({
  selector: 'app-order-response',
  templateUrl: './order-response.component.html',
  styleUrls: ['./order-response.component.scss']
})
export class OrderResponseComponent implements OnInit {

  public products = products;
  order: Order;
  placeInfo=null;
  @Output() stepConfirm = new EventEmitter<number>();

  constructor(private orderService: OrderService, private loaderService:LoaderService) { }

  ngOnInit(): void {
    this.loaderService
    .getCustomerDetails()
    .pipe()
    .subscribe((customer) => {
      this.placeInfo = customer;
    });
    this.orderService
      .getOrder()
      //   .pipe(takeUntil())
      .subscribe((order: Order) => {
        this.order = order;
      });
  }

  confirm(){
    this.stepConfirm.emit(1);
  }
  back(){
    this.stepConfirm.emit(-1);
  }

}
